import type { SVGProps } from 'react';
const SvgIconVideo = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width={26} height={26} {...props}>
    <path
      fill="#1A202C"
      d="M3 8.222C3 6.997 3.997 6 5.222 6h8.89c1.225 0 2.221.997 2.221 2.222v8.889a2.224 2.224 0 0 1-2.222 2.222H5.222A2.224 2.224 0 0 1 3 17.111zm19.413-.979c.361.194.587.57.587.98v8.888a1.112 1.112 0 0 1-1.73.923l-3.332-2.222-.494-.33V9.851l.494-.33 3.333-2.222c.34-.226.778-.25 1.142-.056"
    />
  </svg>
);
export default SvgIconVideo;
